import React from "react"
import {formatTextTestIds} from "@next/utils"
import {Container, Title} from "./component"
import {TitleWrapper} from "../CatalogueItem/component"
import {PrimaryNavItem} from "../../models/primary-nav"
import configRelativePathURL from "../../utils/configUrlPath"
import {NAV_BAR} from "../../config/constants"

type BurgerPrimaryItemLinkProps = PrimaryNavItem & {
    itemKey: string
    siteUrl: string
    target: string
    index: number
    realm: string
    variant: string
    iconsVersionPath: string
}
export const BurgerPrimaryItemDirectLink = ({
    itemKey,
    index,
    title,
    linkColour,
    fontWeight,
    siteUrl,
    target,
}: BurgerPrimaryItemLinkProps) => {
    const linkProps = {
        "data-ga-v1": NAV_BAR,
        "data-ga-v2": title,
    }

    return (
        <Container
            key={itemKey}
            data-testid={formatTextTestIds(`header-burger-menu-primary-item-${title}`)}
            tabIndex={0}
        >
            <Title
                fontWeight={fontWeight}
                linkColour={linkColour}
                {...linkProps}
                id={`burger-primary-direct-link-${index}`}
            >
                <TitleWrapper href={configRelativePathURL(target, siteUrl)}>{title}</TitleWrapper>
            </Title>
        </Container>
    )
}

export default BurgerPrimaryItemDirectLink
